// Auto-generated by npm run build:tokens — do not edit manually.
import { definePreset } from '@primeuix/themes';
import Aura from '@primeng/themes/aura';

export const Core = definePreset(Aura, {
  primitive: {
    borderRadius: {
      md: '8px',
      lg: '12px',
      xl: '16px'
    }
  },
  semantic: {
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.color}',
      offset: '1px',
      shadow: 'none'
    },
    formField: {
      borderRadius: '{border.radius.md}'
    },
    overlay: {
      modal: {
        borderRadius: '{border.radius.xl}'
      }
    }
  },
  components: {
    tooltip: {
      root: {
        padding: '{sidebar.tooltip.padding}',
        maxWidth: '{sidebar.tooltip.maxWidth}',
        borderRadius: '{border.radius.md}'
      }
    }
  },
  extend: {
    spacing: {
      '2xs': '0.125rem',
      xs: '0.25rem',
      s: '0.5rem',
      m: '0.75rem',
      l: '1rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '2rem',
      '4xl': '2.5rem',
      '5xl': '3rem',
      '6xl': '4rem'
    },
    font: {
      weight: {
        light: '300',
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
        black: '800'
      },
      size: {
        xs: '0.75rem',
        s: '0.875rem',
        m: '1rem',
        l: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.75rem',
        '4xl': '2.25rem',
        '5xl': '2.5rem',
        '6xl': '3rem',
        '7xl': '4rem'
      },
      lineHeight: {
        none: '1',
        tight: '1.2',
        snug: '1.4',
        normal: '1.5',
        relaxed: '1.75'
      },
      letterSpacing: {
        tight: '-0.02em',
        normal: '0',
        wide: '0.02em'
      }
    },
    borderRadius: {
      none: '0',
      sm: '4px',
      '2xl': '32px',
      full: '50%',
      pill: '9999px'
    },
    radius: {
      button: '{border.radius.md}',
      card: '{border.radius.lg}',
      panel: '{border.radius.xl}',
      modal: '{border.radius.xl}',
      input: '{border.radius.md}',
      badge: '{border.radius.pill}'
    },
    icon: {
      size: {
        xs: '12px',
        sm: '16px',
        md: '20px',
        lg: '24px',
        xl: '32px',
        '2xl': '40px',
        '3xl': '48px'
      }
    },
    control: {
      height: {
        sm: '32px',
        md: '40px',
        lg: '48px',
        xl: '52px'
      }
    },
    opacity: {
      '0': '0',
      '5': '0.05',
      '10': '0.1',
      '15': '0.15',
      '20': '0.2',
      '25': '0.25',
      '30': '0.3',
      '35': '0.35',
      '40': '0.4',
      '45': '0.45',
      '50': '0.5',
      '55': '0.55',
      '60': '0.6',
      '65': '0.65',
      '70': '0.7',
      '80': '0.8',
      '90': '0.9',
      '100': '1'
    },
    shadow: {
      elevation: {
        '1': '0 1px 2px 0 rgba(18, 18, 23, 0.05)',
        '2': '0 4px 12px rgba(0, 0, 0, 0.1)',
        '3': '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -5px rgba(0, 0, 0, 0.1)',
        '4': '0 12px 30px rgba(0, 0, 0, 0.4), 0 8px 25px rgba(0, 0, 0, 0.3)',
        '1Strong': '0 1px 3px rgba(0, 0, 0, 0.2)',
        '2Hover': '0 8px 18px rgba(0, 0, 0, 0.1)',
        '2Light': '0 4px 12px rgba(0, 0, 0, 0.05)',
        '3Light': '0 8px 24px rgba(0, 0, 0, 0.1)',
        '3Strong': '0 6px 14px rgba(0, 0, 0, 0.1)'
      },
      insetSubtle: '0 4px 30px rgba(0, 0, 0, 0.1) inset',
      insetBorder: '1px 1px 0 0 rgba(0, 0, 0, 0.05) inset',
      subtle: '0 2px 8px rgba(0, 0, 0, 0.1)',
      subtleStrong: '0 2px 6px rgba(0, 0, 0, 0.2)',
      menu: '0 4px 6px rgba(0, 0, 0, 0.05), 0 10px 16px rgba(0, 0, 0, 0.1)',
      toast: '0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
      newsCard: '1px 1px 0 0 rgba(255, 255, 255, 0.35) inset',
      glass: '0 8px 10px -5px rgba(0, 0, 0, 0.2)'
    },
    zIndex: {
      base: '1000'
    },
    glass: {
      blur: {
        lg: '16px',
        xl: '24px'
      },
      glowColor: 'rgba(34, 121, 224, 0.35)',
      glowColorStrong: 'rgba(34, 121, 224, 0.55)',
      glowColorSoft: 'rgba(34, 121, 224, 0.2)',
      focusRingColor: 'rgba(34, 121, 224, 0.35)'
    },
    action: {
      link: {
        light: {
          default: '{primary.color}',
          hover: '{primary.hover.color}',
          active: '{primary.active.color}'
        },
        dark: {
          default: '{primary.color}',
          hover: '{primary.hover.color}',
          active: '{primary.active.color}'
        }
      }
    },
    interaction: {
      pressBg: 'rgba(15, 23, 42, 0.06)',
      pressBgStrong: 'rgba(15, 23, 42, 0.08)'
    },
    scrollbar: {
      thumb: 'rgba(15, 23, 42, 0.25)',
      thumbHover: 'rgba(15, 23, 42, 0.35)',
      track: 'transparent',
      border: 'transparent'
    },
    nav: {
      width: {
        closed: '100px',
        open: '280px',
        max: '480px'
      },
      itemHeight: '{control.height.xl}',
      padding: '{spacing.s}',
      radius: '{border.radius.xl}',
      corner: {
        thickness: '2px',
        radius: '{border.radius.md}',
        lenXHover: '50%',
        lenXClick: '80%',
        lenY: '30%'
      },
      fontSize: '{font.size.2xl}',
      fontWeight: '{font.weight.black}',
      bg: 'rgba(0, 0, 0, 0.4)',
      textColor: '#f3f4f6',
      borderColor: 'rgba(255, 255, 255, 0.15)'
    },
    sidebar: {
      width: {
        collapsed: '56px',
        min: '56px',
        max: '400px'
      },
      radius: '{border.radius.xl}',
      separator: {
        thickness: '1px'
      },
      item: {
        height: '{control.height.md}',
        padding: '{spacing.xs}',
        gap: '{spacing.xs}',
        radius: '{border.radius.md}'
      },
      iconSize: '{icon-size.lg}',
      fontSize: '{font.size.xs}',
      lineHeight: '{line.height.snug}',
      tooltip: {
        padding: '7px 10.5px',
        maxWidth: '320px'
      },
      toggle: {
        size: '{control.height.md}',
        iconSize: '{icon-size.sm}'
      },
      transition: {
        expand: '250ms ease-in-out',
        fade: '200ms ease-out',
        slide: '280ms cubic-bezier(0.4, 0, 0.2, 1)'
      }
    }
  }
});
